export const conditionsActions = {
  FETCH_CONDITIONS: 'FETCH_CONDITIONS',
  FETCH_CONDITIONS_SUCCESS: 'FETCH_CONDITIONS_SUCCESS',
  FETCH_CONDITIONS_ERROR: 'FETCH_CONDITIONS_ERROR',
};

const datasetConditionActions = {
  ADD_DATASET_CONDITION_ERROR: 'ADD_DATASET_CONDITION_ERROR',
  ADD_DATASET_CONDITION_SUCCESS: 'ADD_DATASET_CONDITION_SUCCESS',
  ADD_DATASET_CONDITION: 'ADD_DATASET_CONDITION',
  CLOSE_DATASET_CONDITIONS: 'CLOSE_DATASET_CONDITIONS',
  DESTROY_DATASET_CONDITIONS: 'DESTROY_DATASET_CONDITIONS',
  DOWNLOAD_DATASET_CONDITION_ATTACHMENT_ERROR: 'DOWNLOAD_DATASET_CONDITION_ATTACHMENT_ERROR',
  DOWNLOAD_DATASET_CONDITION_ATTACHMENT_SUCCESS: 'DOWNLOAD_DATASET_CONDITION_ATTACHMENT_SUCCESS',
  DOWNLOAD_DATASET_CONDITION_ATTACHMENT: 'DOWNLOAD_DATASET_CONDITION_ATTACHMENT',
  FETCH_DATASET_CONDITIONS: 'FETCH_DATASET_CONDITIONS',
  FETCH_DATASET_CONDITIONS_ERROR: 'FETCH_DATASET_CONDITIONS_ERROR',
  FETCH_DATASET_CONDITIONS_SUCCESS: 'FETCH_DATASET_CONDITIONS_SUCCESS',
  HIDE_DATASET_CONDITION: 'HIDE_DATASET_CONDITION',
  HIDE_DATASET_CONDITIONS: 'HIDE_DATASET_CONDITIONS',
  HIDE_REMOVE_DATASET_CONDITION: 'HIDE_REMOVE_DATASET_CONDITION',
  REMOVE_DATASET_CONDITION_ERROR: 'REMOVE_DATASET_CONDITION_ERROR',
  REMOVE_DATASET_CONDITION_SUCCESS: 'REMOVE_DATASET_CONDITION_SUCCESS',
  REMOVE_DATASET_CONDITION: 'REMOVE_DATASET_CONDITION',
  SHOW_ADD_DATASET_CONDITION: 'SHOW_ADD_DATASET_CONDITION',
  SHOW_DATASET_CONDITIONS_ERROR: 'SHOW_DATASET_CONDITIONS_ERROR',
  SHOW_DATASET_CONDITIONS_SUCCESS: 'SHOW_DATASET_CONDITIONS_SUCCESS',
  SHOW_DATASET_CONDITIONS: 'SHOW_DATASET_CONDITIONS',
  SHOW_EDIT_DATASET_CONDITION: 'SHOW_EDIT_DATASET_CONDITION',
  SHOW_REMOVE_DATASET_CONDITION: 'SHOW_REMOVE_DATASET_CONDITION',
  TOGGLE_DATASET_CONDITION_ADVISORY_ERROR: 'TOGGLE_DATASET_CONDITION_ADVISORY_ERROR',
  TOGGLE_DATASET_CONDITION_ADVISORY: 'TOGGLE_DATASET_CONDITION_ADVISORY',
  UPDATE_ACTIVE_DATASET_CONDITION_CONFIGURATION: 'UPDATE_ACTIVE_DATASET_CONDITION_CONFIGURATION',
  UPDATE_ACTIVE_DATASET_CONDITION_CONTEXT: 'UPDATE_ACTIVE_DATASET_CONDITION_CONTEXT',
  UPDATE_ACTIVE_DATASET_CONDITION_PROPERTIES: 'UPDATE_ACTIVE_DATASET_CONDITION_PROPERTIES',
  UPDATE_ACTIVE_DATASET_CONDITION: 'UPDATE_ACTIVE_DATASET_CONDITION',
  UPDATE_DATASET_CONDITION_ERROR: 'UPDATE_DATASET_CONDITION_ERROR',
  UPDATE_DATASET_CONDITION_SUCCESS: 'UPDATE_DATASET_CONDITION_SUCCESS',
  UPDATE_DATASET_CONDITION: 'UPDATE_DATASET_CONDITION',
};

export const UserDefinedRestrictionTypes = {
  TEXT: 'text',
  LINK: 'link',
  ATTACHMENT: 'attachment',
};

export const restrictionAttachmentParams = {
  maxFileSize: 104857600, // ~100MB
  allowedExtensions: ['.pdf', '.doc', '.docx', '.odt'],
};

export default datasetConditionActions;
